import React from "react";
import { TableBody } from "@mui/material";
import { TableHead, TableRow } from "@mui/material";
import { IMesDois, IMesUm } from "../../../Interfaces/eficiencia_alimentar/cc_caderno_campo";
import { StyledTableCell, StyledTableHead, StyledTableHeadLeft } from "../../../Styles/tabelCellStyled/customTableCell";
import { desformatarNumero, formatarNumero_recebido_com_casa_decimais } from "../../../Func_genericas/formatar_numero_formato_pt";
interface IJaneiroGH1Props {
  tabela: IMesUm | undefined;
  tabela_editavel: IMesDois | undefined;

}

export const Tabelanaoeditavel: React.FC<IJaneiroGH1Props> = ({
  tabela,
  tabela_editavel
}) => {

  return (
    <table width="80%">
      <TableHead>
        <TableRow>
          <StyledTableHead rowSpan={2} >
            Efetivo pecuário
          </StyledTableHead>
          <StyledTableHead colSpan={4}>
            Tipo de alimento (ton/mês)
          </StyledTableHead>
          <StyledTableHead rowSpan={2}>
            ANEXAR RÓTULO ALIMENTO COMPOSTO
          </StyledTableHead>
        </TableRow>
        <TableRow>
          <StyledTableHead>Pastagem</StyledTableHead>
          <StyledTableHead>Silagem</StyledTableHead>
          <StyledTableHead>Outra Forragem</StyledTableHead>
          <StyledTableHead>Composto</StyledTableHead>
        </TableRow>
      </TableHead>
      <TableBody>
        <TableRow>
          <StyledTableHeadLeft>
            {"Bovinos Machos com < 6 meses"}
          </StyledTableHeadLeft>
          <StyledTableCell>
            {tabela?.bovinos_M_menor_seis_Pastagem === 0 ? '0,00' : tabela?.bovinos_M_menor_seis_Pastagem.toFixed(3).toString().replace('.', ',')}
          </StyledTableCell>
          <StyledTableCell>
            {tabela?.bovinos_M_menor_seis_Silagem === 0 ? '0,00' : tabela?.bovinos_M_menor_seis_Silagem.toFixed(3).toString().replace('.', ',')}
          </StyledTableCell>
          <StyledTableCell>
            {tabela?.bovinos_M_menor_seis_outra_ferragem === 0 ? '0,00' : tabela?.bovinos_M_menor_seis_outra_ferragem.toFixed(3).toString().replace('.', ',')}

          </StyledTableCell>
          <StyledTableCell>
            {tabela?.bovinos_M_menor_seis_Composto === 0 ? '0,00' : tabela?.bovinos_M_menor_seis_Composto.toFixed(3).toString().replace('.', ',')}

          </StyledTableCell>
          <StyledTableCell>{ } </StyledTableCell>
        </TableRow>
        <TableRow>
          <StyledTableHeadLeft>
            {"Bovinos Fêmeas com < 6 meses"}
          </StyledTableHeadLeft>
          <StyledTableCell>
            {tabela?.bovinos_F_menor_seis_Pastagem === 0 ? '0,00' : tabela?.bovinos_F_menor_seis_Pastagem.toFixed(3).toString().replace('.', ',')}

          </StyledTableCell>
          <StyledTableCell>
            {tabela?.bovinos_F_menor_seis_Silagem === 0 ? '0,00' : tabela?.bovinos_F_menor_seis_Silagem.toFixed(3).toString().replace('.', ',')}

          </StyledTableCell>
          <StyledTableCell>
            {tabela?.bovinos_F_menor_seis_outra_ferragem === 0 ? '0,00' : tabela?.bovinos_F_menor_seis_outra_ferragem.toFixed(3).toString().replace('.', ',')}

          </StyledTableCell>
          <StyledTableCell>
            {tabela?.bovinos_F_menor_seis_Composto === 0 ? '0,00' : tabela?.bovinos_F_menor_seis_Composto.toFixed(3).toString().replace('.', ',')}

          </StyledTableCell>
          <StyledTableCell>{ } </StyledTableCell>

        </TableRow>
        <TableRow>
          <StyledTableHeadLeft>
            {"Bovinos Machos de 6 meses a < 1 ano"}
          </StyledTableHeadLeft>
          <StyledTableCell>
            {tabela?.bovinos_M_seis_um_Pastagem === 0 ? '0,00' : tabela?.bovinos_M_seis_um_Pastagem.toFixed(3).toString().replace('.', ',')}

          </StyledTableCell>
          <StyledTableCell>
            {tabela?.bovinos_M_seis_um_Silagem === 0 ? '0,00' : tabela?.bovinos_M_seis_um_Silagem.toFixed(3).toString().replace('.', ',')}

          </StyledTableCell>
          <StyledTableCell>
            {tabela?.bovinos_M_seis_um_outra_ferragem === 0 ? '0,00' : tabela?.bovinos_M_seis_um_outra_ferragem.toFixed(3).toString().replace('.', ',')}

          </StyledTableCell>
          <StyledTableCell>
            {tabela?.bovinos_M_seis_um_Composto === 0 ? '0,00' : tabela?.bovinos_M_seis_um_Composto.toFixed(3).toString().replace('.', ',')}

          </StyledTableCell>
          <StyledTableCell>{ } </StyledTableCell>

        </TableRow>
        <TableRow>
          <StyledTableHeadLeft>
            {"Bovinos Fêmeas de 6 meses a < 1 ano"}
          </StyledTableHeadLeft>
          <StyledTableCell>
            {tabela?.bovinos_F_seis_um_Pastagem === 0 ? '0,00' : tabela?.bovinos_F_seis_um_Pastagem.toFixed(3).toString().replace('.', ',')}

          </StyledTableCell>
          <StyledTableCell>
            {tabela?.bovinos_F_seis_um_Silagem === 0 ? '0,00' : tabela?.bovinos_F_seis_um_Silagem.toFixed(3).toString().replace('.', ',')}

          </StyledTableCell>
          <StyledTableCell>
            {tabela?.bovinos_F_seis_um_outra_ferragem === 0 ? '0,00' : tabela?.bovinos_F_seis_um_outra_ferragem.toFixed(3).toString().replace('.', ',')}

          </StyledTableCell>
          <StyledTableCell>
            {tabela?.bovinos_F_seis_um_Composto === 0 ? '0,00' : tabela?.bovinos_F_seis_um_Composto.toFixed(3).toString().replace('.', ',')}

          </StyledTableCell>
          <StyledTableCell>{ } </StyledTableCell>

        </TableRow>
        <TableRow>
          <StyledTableHeadLeft>
            {"Bovinos Machos de 1 ano a < 2 anos"}
          </StyledTableHeadLeft>
          <StyledTableCell>
            {tabela?.bovinos_M_um_dois_Pastagem === 0 ? '0,00' : tabela?.bovinos_M_um_dois_Pastagem.toFixed(3).toString().replace('.', ',')}

          </StyledTableCell>
          <StyledTableCell>
            {tabela?.bovinos_M_um_dois_Silagem === 0 ? '0,00' : tabela?.bovinos_M_um_dois_Silagem.toFixed(3).toString().replace('.', ',')}

          </StyledTableCell>
          <StyledTableCell>
            {tabela?.bovinos_M_um_dois_outra_ferragem === 0 ? '0,00' : tabela?.bovinos_M_um_dois_outra_ferragem.toFixed(3).toString().replace('.', ',')}

          </StyledTableCell>
          <StyledTableCell>
            {tabela?.bovinos_M_um_dois_Composto === 0 ? '0,00' : tabela?.bovinos_M_um_dois_Composto.toFixed(3).toString().replace('.', ',')}

          </StyledTableCell>
          <StyledTableCell>{ } </StyledTableCell>

        </TableRow>
        <TableRow>
          <StyledTableHeadLeft>
            {"Bovinos Fêmeas de 1 ano a < 2 anos"}
          </StyledTableHeadLeft>
          <StyledTableCell>
            {tabela?.bovinos_F_um_dois_Pastagem === 0 ? '0,00' : tabela?.bovinos_F_um_dois_Pastagem.toFixed(3).toString().replace('.', ',')}

          </StyledTableCell>
          <StyledTableCell>
            {tabela?.bovinos_F_um_dois_Silagem === 0 ? '0,00' : tabela?.bovinos_F_um_dois_Silagem.toFixed(3).toString().replace('.', ',')}

          </StyledTableCell>
          <StyledTableCell>
            {tabela?.bovinos_F_um_dois_outra_ferragem === 0 ? '0,00' : tabela?.bovinos_F_um_dois_outra_ferragem.toFixed(3).toString().replace('.', ',')}

          </StyledTableCell>
          <StyledTableCell>
            {tabela?.bovinos_F_um_dois_Composto === 0 ? '0,00' : tabela?.bovinos_F_um_dois_Composto.toFixed(3).toString().replace('.', ',')}

          </StyledTableCell>
          <StyledTableCell>{ } </StyledTableCell>

        </TableRow>
        <TableRow>
          <StyledTableHeadLeft>
            {"Bovinos Machos com ≥ 2 anos"}
          </StyledTableHeadLeft>
          <StyledTableCell>
            {tabela?.bovinos_M_maior_dois_Pastagem === 0 ? '0,00' : tabela?.bovinos_M_maior_dois_Pastagem.toFixed(3).toString().replace('.', ',')}

          </StyledTableCell>
          <StyledTableCell>
            {tabela?.bovinos_M_maior_dois_Silagem === 0 ? '0,00' : tabela?.bovinos_M_maior_dois_Silagem.toFixed(3).toString().replace('.', ',')}

          </StyledTableCell>
          <StyledTableCell>
            {tabela?.bovinos_M_maior_dois_outra_ferragem === 0 ? '0,00' : tabela?.bovinos_M_maior_dois_outra_ferragem.toFixed(3).toString().replace('.', ',')}

          </StyledTableCell>
          <StyledTableCell>
            {tabela?.bovinos_M_maior_dois_Composto === 0 ? '0,00' : tabela?.bovinos_M_maior_dois_Composto.toFixed(3).toString().replace('.', ',')}

          </StyledTableCell>
          <StyledTableCell>{ } </StyledTableCell>

        </TableRow>
        <TableRow>
          <StyledTableHeadLeft>
            {"Bovinos Fêmeas com ≥ 2 anos"}
          </StyledTableHeadLeft>
          <StyledTableCell>
            {tabela?.bovinos_F_maior_dois_Pastagem === 0 ? '0,00' : tabela?.bovinos_F_maior_dois_Pastagem.toFixed(3).toString().replace('.', ',')}

          </StyledTableCell>
          <StyledTableCell>
            {tabela?.bovinos_F_maior_dois_Silagem === 0 ? '0,00' : tabela?.bovinos_F_maior_dois_Silagem.toFixed(3).toString().replace('.', ',')}

          </StyledTableCell>
          <StyledTableCell>
            {tabela?.bovinos_F_maior_dois_outra_ferragem === 0 ? '0,00' : tabela?.bovinos_F_maior_dois_outra_ferragem.toFixed(3).toString().replace('.', ',')}

          </StyledTableCell>
          <StyledTableCell>
            {tabela?.bovinos_F_maior_dois_Composto === 0 ? '0,00' : tabela?.bovinos_F_maior_dois_Composto.toFixed(3).toString().replace('.', ',')}

          </StyledTableCell>
          <StyledTableCell>{ } </StyledTableCell>

        </TableRow>
        <TableRow>
          <StyledTableHeadLeft sx={{ textAlign: "right" }}>
            Sub-Total
          </StyledTableHeadLeft>
          <StyledTableCell>
            {formatarNumero_recebido_com_casa_decimais(
              ((desformatarNumero(tabela_editavel?.bovinos_M_menor_seis_Num_Animais) * desformatarNumero(tabela_editavel?.bovinos_M_menor_seis_Num_Dias) * desformatarNumero(tabela_editavel?.bovinos_M_menor_seis_Pastagem)) / 1000) +
              ((desformatarNumero(tabela_editavel?.bovinos_F_menor_seis_Num_Animais) * desformatarNumero(tabela_editavel?.bovinos_F_menor_seis_Num_Dias) * desformatarNumero(tabela_editavel?.bovinos_F_menor_seis_Pastagem)) / 1000) +
              ((desformatarNumero(tabela_editavel?.bovinos_M_seis_um_Num_Animais) * desformatarNumero(tabela_editavel?.bovinos_M_seis_um_Num_Dias) * desformatarNumero(tabela_editavel?.bovinos_M_seis_um_Pastagem)) / 1000) +
              ((desformatarNumero(tabela_editavel?.bovinos_F_seis_um_Num_Animais) * desformatarNumero(tabela_editavel?.bovinos_F_seis_um_Num_Dias) * desformatarNumero(tabela_editavel?.bovinos_F_seis_um_Pastagem)) / 1000) +
              ((desformatarNumero(tabela_editavel?.bovinos_M_um_dois_Num_Animais) * desformatarNumero(tabela_editavel?.bovinos_M_um_dois_Num_Dias) * desformatarNumero(tabela_editavel?.bovinos_M_um_dois_Pastagem)) / 1000) +
              ((desformatarNumero(tabela_editavel?.bovinos_F_um_dois_Num_Animais) * desformatarNumero(tabela_editavel?.bovinos_F_um_dois_Num_Dias) * desformatarNumero(tabela_editavel?.bovinos_F_um_dois_Pastagem)) / 1000) +
              ((desformatarNumero(tabela_editavel?.bovinos_M_maior_dois_Num_Animais) * desformatarNumero(tabela_editavel?.bovinos_M_maior_dois_Num_Dias) * desformatarNumero(tabela_editavel?.bovinos_M_maior_dois_Pastagem)) / 1000) +
              ((desformatarNumero(tabela_editavel?.bovinos_F_maior_dois_Num_Animais) * desformatarNumero(tabela_editavel?.bovinos_F_maior_dois_Num_Dias) * desformatarNumero(tabela_editavel?.bovinos_F_maior_dois_Pastagem)) / 1000)
            )}
          </StyledTableCell>
          <StyledTableCell>
            {formatarNumero_recebido_com_casa_decimais(
              ((desformatarNumero(tabela_editavel?.bovinos_M_menor_seis_Num_Animais) * desformatarNumero(tabela_editavel?.bovinos_M_menor_seis_Num_Dias) * desformatarNumero(tabela_editavel?.bovinos_M_menor_seis_Silagem)) / 1000) +
              ((desformatarNumero(tabela_editavel?.bovinos_F_menor_seis_Num_Animais) * desformatarNumero(tabela_editavel?.bovinos_F_menor_seis_Num_Dias) * desformatarNumero(tabela_editavel?.bovinos_F_menor_seis_Silagem)) / 1000) +
              ((desformatarNumero(tabela_editavel?.bovinos_M_seis_um_Num_Animais) * desformatarNumero(tabela_editavel?.bovinos_M_seis_um_Num_Dias) * desformatarNumero(tabela_editavel?.bovinos_M_seis_um_Silagem)) / 1000) +
              ((desformatarNumero(tabela_editavel?.bovinos_F_seis_um_Num_Animais) * desformatarNumero(tabela_editavel?.bovinos_F_seis_um_Num_Dias) * desformatarNumero(tabela_editavel?.bovinos_F_seis_um_Silagem)) / 1000) +
              ((desformatarNumero(tabela_editavel?.bovinos_M_um_dois_Num_Animais) * desformatarNumero(tabela_editavel?.bovinos_M_um_dois_Num_Dias) * desformatarNumero(tabela_editavel?.bovinos_M_um_dois_Silagem)) / 1000) +
              ((desformatarNumero(tabela_editavel?.bovinos_F_um_dois_Num_Animais) * desformatarNumero(tabela_editavel?.bovinos_F_um_dois_Num_Dias) * desformatarNumero(tabela_editavel?.bovinos_F_um_dois_Silagem)) / 1000) +
              ((desformatarNumero(tabela_editavel?.bovinos_M_maior_dois_Num_Animais) * desformatarNumero(tabela_editavel?.bovinos_M_maior_dois_Num_Dias) * desformatarNumero(tabela_editavel?.bovinos_M_maior_dois_Silagem)) / 1000) +
              ((desformatarNumero(tabela_editavel?.bovinos_F_maior_dois_Num_Animais) * desformatarNumero(tabela_editavel?.bovinos_F_maior_dois_Num_Dias) * desformatarNumero(tabela_editavel?.bovinos_F_maior_dois_Silagem)) / 1000)
            )}
          </StyledTableCell>
          <StyledTableCell>
            {formatarNumero_recebido_com_casa_decimais(
              ((desformatarNumero(tabela_editavel?.bovinos_M_menor_seis_Num_Animais) * desformatarNumero(tabela_editavel?.bovinos_M_menor_seis_Num_Dias) * desformatarNumero(tabela_editavel?.bovinos_M_menor_seis_outra_ferragem)) / 1000) +
              ((desformatarNumero(tabela_editavel?.bovinos_F_menor_seis_Num_Animais) * desformatarNumero(tabela_editavel?.bovinos_F_menor_seis_Num_Dias) * desformatarNumero(tabela_editavel?.bovinos_F_menor_seis_outra_ferragem)) / 1000) +
              ((desformatarNumero(tabela_editavel?.bovinos_M_seis_um_Num_Animais) * desformatarNumero(tabela_editavel?.bovinos_M_seis_um_Num_Dias) * desformatarNumero(tabela_editavel?.bovinos_M_seis_um_outra_ferragem)) / 1000) +
              ((desformatarNumero(tabela_editavel?.bovinos_F_seis_um_Num_Animais) * desformatarNumero(tabela_editavel?.bovinos_F_seis_um_Num_Dias) * desformatarNumero(tabela_editavel?.bovinos_F_seis_um_outra_ferragem)) / 1000) +
              ((desformatarNumero(tabela_editavel?.bovinos_M_um_dois_Num_Animais) * desformatarNumero(tabela_editavel?.bovinos_M_um_dois_Num_Dias) * desformatarNumero(tabela_editavel?.bovinos_M_um_dois_outra_ferragem)) / 1000) +
              ((desformatarNumero(tabela_editavel?.bovinos_F_um_dois_Num_Animais) * desformatarNumero(tabela_editavel?.bovinos_F_um_dois_Num_Dias) * desformatarNumero(tabela_editavel?.bovinos_F_um_dois_outra_ferragem)) / 1000) +
              ((desformatarNumero(tabela_editavel?.bovinos_M_maior_dois_Num_Animais) * desformatarNumero(tabela_editavel?.bovinos_M_maior_dois_Num_Dias) * desformatarNumero(tabela_editavel?.bovinos_M_maior_dois_outra_ferragem)) / 1000) +
              ((desformatarNumero(tabela_editavel?.bovinos_F_maior_dois_Num_Animais) * desformatarNumero(tabela_editavel?.bovinos_F_maior_dois_Num_Dias) * desformatarNumero(tabela_editavel?.bovinos_F_maior_dois_outra_ferragem)) / 1000)
            )}
          </StyledTableCell>
          <StyledTableCell>
            {formatarNumero_recebido_com_casa_decimais(
              ((desformatarNumero(tabela_editavel?.bovinos_M_menor_seis_Num_Animais) * desformatarNumero(tabela_editavel?.bovinos_M_menor_seis_Num_Dias) * desformatarNumero(tabela_editavel?.bovinos_M_menor_seis_Composto)) / 1000) +
              ((desformatarNumero(tabela_editavel?.bovinos_F_menor_seis_Num_Animais) * desformatarNumero(tabela_editavel?.bovinos_F_menor_seis_Num_Dias) * desformatarNumero(tabela_editavel?.bovinos_F_menor_seis_Composto)) / 1000) +
              ((desformatarNumero(tabela_editavel?.bovinos_M_seis_um_Num_Animais) * desformatarNumero(tabela_editavel?.bovinos_M_seis_um_Num_Dias) * desformatarNumero(tabela_editavel?.bovinos_M_seis_um_Composto)) / 1000) +
              ((desformatarNumero(tabela_editavel?.bovinos_F_seis_um_Num_Animais) * desformatarNumero(tabela_editavel?.bovinos_F_seis_um_Num_Dias) * desformatarNumero(tabela_editavel?.bovinos_F_seis_um_Composto)) / 1000) +
              ((desformatarNumero(tabela_editavel?.bovinos_M_um_dois_Num_Animais) * desformatarNumero(tabela_editavel?.bovinos_M_um_dois_Num_Dias) * desformatarNumero(tabela_editavel?.bovinos_M_um_dois_Composto)) / 1000) +
              ((desformatarNumero(tabela_editavel?.bovinos_F_um_dois_Num_Animais) * desformatarNumero(tabela_editavel?.bovinos_F_um_dois_Num_Dias) * desformatarNumero(tabela_editavel?.bovinos_F_um_dois_Composto)) / 1000) +
              ((desformatarNumero(tabela_editavel?.bovinos_M_maior_dois_Num_Animais) * desformatarNumero(tabela_editavel?.bovinos_M_maior_dois_Num_Dias) * desformatarNumero(tabela_editavel?.bovinos_M_maior_dois_Composto)) / 1000) +
              ((desformatarNumero(tabela_editavel?.bovinos_F_maior_dois_Num_Animais) * desformatarNumero(tabela_editavel?.bovinos_F_maior_dois_Num_Dias) * desformatarNumero(tabela_editavel?.bovinos_F_maior_dois_Composto)) / 1000)
            )}
          </StyledTableCell>
          <StyledTableCell>{ } </StyledTableCell>
        </TableRow>

      </TableBody>
    </table>
  );
};
